import { createContext, useContext, useEffect } from 'react';

type Ctx = { overHero: boolean; setOverHero: (v: boolean) => void };

export const HeaderCtx = createContext<Ctx>({ overHero: false, setOverHero: () => {} });

export const useHeader = () => useContext(HeaderCtx);

/** À appeler dans un hero: rend le header transparent tant que le hero est visible. */
export function useTransparentHeader() {
  const { setOverHero } = useHeader();
  useEffect(() => {
    setOverHero(true);
    return () => setOverHero(false);
  }, [setOverHero]);
}
